import React from "react";
import { useDispatch } from "react-redux";
import { TextField, Grid, Typography, Checkbox } from "@material-ui/core";
import { getLocalizedString } from "@icarius-localization/strings";
import ButtonDialogAction from "@icarius-common/buttonDialogAction";
import { createConceptGroupsAction, updateConceptGroupsAction } from "../../actions";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import useHandleForm from "./useHandleForm";

const gridStyle = { height: 75, padding: "0px 10px" };

const Form = (props) => {

  const { data, length, handleClose } = props;
  const dispatch = useDispatch();

  const create = (dataToSend) => {
    dispatch(createConceptGroupsAction(dataToSend))
      .then((res) => res?.status === 200 && handleClose());
  }

  const modify = (dataToSend) => {
    dispatch(updateConceptGroupsAction(dataToSend))
      .then((res) => res?.status === 200 && handleClose());
  }

  const openValidationError = () => {
    dispatch(openSnackbarAction({ msg: getLocalizedString("invalidData"), severity: "error", duration: 10000 }));
  }

  const {
    formData,
    setFormValue,
    submit
  } = useHandleForm(data, create, modify, openValidationError);

  return (
    <Grid container item xs={12} direction="row" style={{ paddingTop: 10 }}>
      <Grid container item xs={12}>
        <Grid container item alignItems="center" xs={12} sm={6} md={2} style={gridStyle}>
          <TextField
            disabled
            fullWidth
            margin={"none"}
            label={getLocalizedString("groupNumber")}
            value={data?.number || length + 1}
          />
        </Grid>
        <Grid container item alignItems="center" xs={12} sm={6} md={5} style={gridStyle}>
          <TextField
            disabled={data?.inUse}
            required
            fullWidth
            margin={"none"}
            label={getLocalizedString("groupName")}
            value={formData.conceptGroup}
            onChange={(e) => setFormValue(e.target.value, "conceptGroup")}
            inputProps={{ maxLength: 60 }}
          />
        </Grid>
        <Grid container item alignItems="center" xs={12} sm={6} md={5} style={gridStyle}>
          <div
            style={{ display: "flex", alignItems: "center", cursor: "pointer", paddingRight: 20 }}
            onClick={() => setFormValue(!Boolean(formData.employerContributionGroup), "employerContributionGroup")}
          >
            <Typography className="whiteText" variant="subtitle1" style={{ display: "inline-block" }}>
              {getLocalizedString("employerContributionGroup")}
            </Typography>
            <Checkbox checked={formData.employerContributionGroup} />
          </div>
        </Grid>
        {
          data?.inUse &&
          <Typography className="whiteText" style={{ marginLeft: 10, fontSize: 14 }}>
            {getLocalizedString("nameCannotBeModifiedBecauseItIsUsedInConceptFormulasOrFunctions")}
          </Typography>
        }
      </Grid>
      <Grid container item xs={12} justify={"flex-end"} alignItems="center" style={{ paddingBottom: 20 }}>
        <ButtonDialogAction isAccept onClick={submit} text={getLocalizedString("save")} />
      </Grid>
    </Grid>
  );
}

export default Form;
